import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-lg-8 ant-col-xl-8" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-lg-8 ant-col-xl-8" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-lg-8 ant-col-xl-8" }
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-lg-16 ant-col-xl-24" }
const _hoisted_8 = { class: "ant-row" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-lg-6 ant-col-xl-6" }
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-lg-9 ant-col-xl-9" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-lg-9 ant-col-xl-9" }
const _hoisted_12 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-lg-12 ant-col-xl-12" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-lg-12 ant-col-xl-12" }
const _hoisted_15 = { class: "ant-row" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-lg-6 ant-col-xl-6" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-lg-6 ant-col-xl-6" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-lg-6 ant-col-xl-6" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-lg-6 ant-col-xl-6" }
const _hoisted_20 = {
  key: 1,
  class: "ant-row"
}
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-lg-12 ant-col-xl-12" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-lg-12 ant-col-xl-12" }
const _hoisted_23 = {
  key: 2,
  class: "ant-row"
}
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-lg-24 ant-col-xl-24" }
const _hoisted_25 = {
  key: 3,
  class: "ant-row"
}
const _hoisted_26 = { class: "ant-col ant-col-xs-24 ant-col-lg-24 ant-col-xl-24" }
const _hoisted_27 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_28 = { class: "ant-col ant-col-xs-24 ant-col-lg-24 ant-col-xl-24" }
const _hoisted_29 = { class: "ant-col ant-col-xs-24 ant-col-lg-8 ant-col-xl-8" }
const _hoisted_30 = { class: "ant-col ant-col-xs-24 ant-col-lg-8 ant-col-xl-8" }
const _hoisted_31 = { class: "ant-col ant-col-xs-24 ant-col-lg-8 ant-col-xl-8" }
const _hoisted_32 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-lg-24 ant-col-xl-24"
}
const _hoisted_33 = {
  key: 1,
  class: "ant-row"
}
const _hoisted_34 = { class: "ant-col ant-col-xs-24 ant-col-lg-12 ant-col-xl-12" }
const _hoisted_35 = { class: "ant-col ant-col-xs-24 ant-col-lg-6 ant-col-xl-6" }
const _hoisted_36 = { class: "ant-col ant-col-xs-24 ant-col-lg-6 ant-col-xl-6" }
const _hoisted_37 = { class: "ant-row" }
const _hoisted_38 = { class: "ant-col ant-col-xs-24 ant-col-lg-24 ant-col-xl-24" }
const _hoisted_39 = ["onUpdate:modelValue"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "ant-row" }
const _hoisted_42 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-lg-4 ant-col-xl-4"
}
const _hoisted_43 = { class: "ant-col ant-col-xs-24 ant-col-lg-4 ant-col-xl-4" }
const _hoisted_44 = { class: "ant-col ant-col-xs-24 ant-col-lg-4 ant-col-xl-4" }
const _hoisted_45 = { class: "ant-row" }
const _hoisted_46 = { class: "ant-col ant-col-xs-24 ant-col-lg-8 ant-col-xl-8" }
const _hoisted_47 = { class: "ant-col ant-col-xs-24 ant-col-lg-8 ant-col-xl-8" }
const _hoisted_48 = { class: "ant-col ant-col-xs-24 ant-col-lg-8 ant-col-xl-8" }
const _hoisted_49 = { class: "ant-row" }
const _hoisted_50 = { class: "ant-col ant-col-xs-24 ant-col-lg-12 ant-col-xl-12" }
const _hoisted_51 = { class: "ant-col ant-col-xs-24 ant-col-lg-12 ant-col-xl-12" }
const _hoisted_52 = { class: "ant-row" }
const _hoisted_53 = { class: "ant-col ant-col-xs-24 ant-col-lg-14 ant-col-xl-14" }
const _hoisted_54 = ["onUpdate:modelValue"]
const _hoisted_55 = { class: "ant-col ant-col-xs-24 ant-col-lg-3 ant-col-xl-3" }
const _hoisted_56 = ["onUpdate:modelValue"]
const _hoisted_57 = { class: "ant-col ant-col-xs-24 ant-col-lg-3 ant-col-xl-3" }
const _hoisted_58 = { class: "ant-col ant-col-xs-24 ant-col-lg-4 ant-col-xl-4" }
const _hoisted_59 = ["onUpdate:modelValue"]
const _hoisted_60 = ["onClick"]
const _hoisted_61 = { class: "ant-row" }
const _hoisted_62 = { class: "ant-col ant-col-xs-24 ant-col-lg-14 ant-col-xl-14" }
const _hoisted_63 = ["onUpdate:modelValue"]
const _hoisted_64 = { class: "ant-col ant-col-xs-24 ant-col-lg-10 ant-col-xl-10" }
const _hoisted_65 = ["onUpdate:modelValue"]
const _hoisted_66 = { class: "ant-row" }
const _hoisted_67 = { class: "ant-col ant-col-xs-24 ant-col-lg-6 ant-col-xl-4" }
const _hoisted_68 = { class: "ant-col ant-col-xs-24 ant-col-lg-6 ant-col-xl-4" }
const _hoisted_69 = { class: "ant-col ant-col-xs-24 ant-col-lg-12 ant-col-xl-16" }
const _hoisted_70 = ["onUpdate:modelValue"]
const _hoisted_71 = /*#__PURE__*/_createElementVNode("h3", { style: {"font-weight":"900"} }, "Aceite nosso Termo de Consentimento para Tratamento de Dados Pessoais", -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("p", null, "Eu, na qualidade de usuário visitante do site www.frigorificoverdi.com.br, titular dos dados pessoais informados no meu currículo, reconheço e concordo que o Frigorífico Verdi, doravante denominado \"controlador\", poderá coletar, armazenar, utilizar e processar tais informações para os fins específicos de recrutamento e seleção de candidatos.", -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("p", null, "Ao fornecer meus dados pessoais, estou ciente de que estes serão tratados de acordo com as disposições da Lei Geral de Proteção de Dados (LGPD - Lei nº 13.709/2018) e demais normas aplicáveis, respeitando-se os princípios de finalidade, adequação, necessidade, livre acesso, qualidade dos dados, transparência, segurança, prevenção, não discriminação e responsabilização.", -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("p", null, "Autorizo expressamente o Frigorífico Verdi a compartilhar meus dados pessoais com terceiros prestadores de serviços que estejam envolvidos no processo de recrutamento e seleção, sempre observando as garantias de segurança e confidencialidade.", -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("p", null, "Declaro ainda estar ciente de que posso revogar este consentimento a qualquer momento, mediante solicitação ao controlador, o que não afetará a legalidade do tratamento dos dados realizado antes da revogação.", -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Concluir Cadastro")
], -1)
const _hoisted_82 = [
  _hoisted_81
]
const _hoisted_83 = /*#__PURE__*/_createElementVNode("h3", { style: {"font-weight":"900"} }, "Política de Privacidade", -1)
const _hoisted_84 = /*#__PURE__*/_createElementVNode("div", { style: {"max-height":"300px","overflow":"auto"} }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Este site é mantido e operado por "),
    /*#__PURE__*/_createElementVNode("strong", null, "HERGEN SA MÁQUINAS E EQUIPAMENTOS .")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "Nós coletamos e utilizamos alguns dados pessoais que pertencem àqueles que utilizam nosso site. Ao fazê-lo, agimos na qualidade de controlador desses dados e estamos sujeitos às disposições da Lei Federal n. 13.709/2018 (Lei Geral de Proteção de Dados Pessoais – LGPD)."),
  /*#__PURE__*/_createElementVNode("p", null, "Nós cuidamos da proteção de seus dados pessoais e, por isso, disponibilizamos esta política de privacidade, que contém informações importantes sobre:"),
  /*#__PURE__*/_createElementVNode("p", null, "– Quem deve utilizar nosso site"),
  /*#__PURE__*/_createElementVNode("p", null, "– Quais dados coletamos e o que fazemos com eles;"),
  /*#__PURE__*/_createElementVNode("p", null, "– Seus direitos em relação aos seus dados pessoais; e"),
  /*#__PURE__*/_createElementVNode("p", null, "– Como entrar em contato conosco."),
  /*#__PURE__*/_createElementVNode("h2", null, "1. Dados que coletamos e motivos da coleta"),
  /*#__PURE__*/_createElementVNode("p", null, "Nosso site coleta e utiliza alguns dados pessoais de nossos usuários, de acordo com o disposto nesta seção."),
  /*#__PURE__*/_createElementVNode("h3", null, "1.1. Dados pessoais fornecidos expressamente pelo usuário"),
  /*#__PURE__*/_createElementVNode("p", null, "Nós coletamos os seguintes dados pessoais que nossos usuários nos fornecem expressamente ao utilizar nosso site:"),
  /*#__PURE__*/_createElementVNode("p", null, "– Nome completo"),
  /*#__PURE__*/_createElementVNode("p", null, "– E-mail"),
  /*#__PURE__*/_createElementVNode("p", null, "A coleta destes dados ocorre nos seguintes momentos:"),
  /*#__PURE__*/_createElementVNode("p", null, "– Quando o usuário utiliza o formulário de contato"),
  /*#__PURE__*/_createElementVNode("p", null, "Os dados fornecidos por nossos usuários são coletados com as seguintes finalidades:"),
  /*#__PURE__*/_createElementVNode("p", null, "– Para que o usuário possa entrar em contato com nossa empresa"),
  /*#__PURE__*/_createElementVNode("p", null, "– Para que possamos oferecer produtos e serviços ao usuário"),
  /*#__PURE__*/_createElementVNode("h3", null, "1.2. Dados sensíveis"),
  /*#__PURE__*/_createElementVNode("p", null, "Não serão coletados dados sensíveis de nossos usuários, assim entendidos aqueles definidos nos arts. 11 e seguintes da Lei de Proteção de Dados Pessoais. Assim, não haverá coleta de dados sobre origem racial ou étnica, convicção religiosa, opinião política, filiação a sindicato ou a organização de caráter religioso, filosófico ou político, dado referente à saúde ou à vida sexual, dado genético ou biométrico, quando vinculado a uma pessoa natural."),
  /*#__PURE__*/_createElementVNode("h3", null, "1.3. Cookies"),
  /*#__PURE__*/_createElementVNode("p", null, "Cookies são pequenos arquivos de texto baixados automaticamente em seu dispositivo quando você acessa e navega por um site. Eles servem, basicamente, para que seja possível identificar dispositivos, atividades e preferências de usuários. Os cookies não permitem que qualquer arquivo ou informação sejam extraídos do disco rígido do usuário, não sendo possível, ainda, que, por meio deles, se tenha acesso a informações pessoais que não tenham partido do usuário ou da forma como utiliza os recursos do site."),
  /*#__PURE__*/_createElementVNode("h4", null, "a. Cookies do site"),
  /*#__PURE__*/_createElementVNode("p", null, "Os cookies do site são aqueles enviados ao computador ou dispositivo do usuário e administrador exclusivamente pelo site."),
  /*#__PURE__*/_createElementVNode("p", null, "As informações coletadas por meio destes cookies são utilizadas para melhorar e personalizar a experiência do usuário, sendo que alguns cookies podem, por exemplo, ser utilizados para lembrar as preferências e escolhas do usuário, bem como para o oferecimento de conteúdo personalizado."),
  /*#__PURE__*/_createElementVNode("h4", null, "b. Cookies de terceiros"),
  /*#__PURE__*/_createElementVNode("p", null, "Alguns de nossos parceiros podem configurar cookies nos dispositivos dos usuários que acessam nosso site."),
  /*#__PURE__*/_createElementVNode("p", null, "Estes cookies, em geral, visam possibilitar que nossos parceiros possam oferecer seu conteúdo e seus serviços ao usuário que acessa nosso site de forma personalizada, por meio da obtenção de dados de navegação extraídos a partir de sua interação com o site."),
  /*#__PURE__*/_createElementVNode("p", null, "O usuário poderá obter mais informações sobre os cookies de terceiro e sobre a forma como os dados obtidos a partir dele são tratados, além de ter acesso à descrição dos cookies utilizados e de suas características, acessando o seguinte link:"),
  /*#__PURE__*/_createElementVNode("p", null, "– Google Analytics:"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      href: "https://developers.google.com/analytics/devguides/collection/gtagjs/cookie-usage"
    }, "https://developers.google.com/analytics/devguides/collection/gtagjs/cookie-usage")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "As entidades encarregadas da coleta dos cookies poderão ceder as informações obtidas a terceiros."),
  /*#__PURE__*/_createElementVNode("h4", null, "c. Gestão de cookies"),
  /*#__PURE__*/_createElementVNode("p", null, "O usuário poderá se opor ao registro de cookies pelo site, bastando que selecione que cookies deseja permitir ou bloquear em seu primeiro acesso ao site, ou que desative esta opção no seu próprio navegador. Mais informações sobre como fazer isso em alguns dos principais navegadores utilizados hoje podem ser acessadas a partir dos seguintes links:"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Internet Explorer:")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      href: "https://support.microsoft.com/pt-br/help/17442/windows-internet-explorer-delete-manage-cookies"
    }, "https://support.microsoft.com/pt-br/help/17442/windows-internet-explorer-delete-manage-cookies")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Safari:")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      href: "https://support.apple.com/pt-br/guide/safari/sfri11471/mac"
    }, "https://support.apple.com/pt-br/guide/safari/sfri11471/mac")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Google Chrome:")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      href: "https://support.google.com/chrome/answer/95647?hl=pt-BR&hlrm=pt"
    }, "https://support.google.com/chrome/answer/95647?hl=pt-BR&hlrm=pt")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Mozila Firefox:")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      href: "https://support.mozilla.org/pt-BR/kb/ative-e-desative-os-cookies-que-os-sites-usam"
    }, "https://support.mozilla.org/pt-BR/kb/ative-e-desative-os-cookies-que-os-sites-usam")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Opera:")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      href: "https://www.opera.com/help/tutorials/security/privacy/"
    }, "https://www.opera.com/help/tutorials/security/privacy/")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "A desativação dos cookies, no entanto, pode afetar a disponibilidade de algumas ferramentas e funcionalidades do site, comprometendo seu correto e esperado funcionamento. Outra consequência possível é remoção das preferências do usuário que eventualmente tiverem sido salvas, prejudicando sua experiência."),
  /*#__PURE__*/_createElementVNode("h3", null, "1.4. Coleta de dados não previstos expressamente"),
  /*#__PURE__*/_createElementVNode("p", null, "Eventualmente, outros tipos de dados não previstos expressamente nesta Política de Privacidade poderão ser coletados, desde que sejam fornecidos com o consentimento do usuário, ou, ainda, que a coleta seja permitida com fundamento em outra base legal prevista em lei."),
  /*#__PURE__*/_createElementVNode("p", null, "Em qualquer caso, a coleta de dados e as atividades de tratamento dela decorrentes serão informadas aos usuários do site."),
  /*#__PURE__*/_createElementVNode("h2", null, "2. Compartilhamento de dados pessoais com terceiros"),
  /*#__PURE__*/_createElementVNode("p", null, "Nós não compartilhamos seus dados pessoais com terceiros. Apesar disso, é possível que o façamos para cumprir alguma determinação legal ou regulatória, ou, ainda, para cumprir alguma ordem expedida por autoridade pública."),
  /*#__PURE__*/_createElementVNode("h2", null, "3. Por quanto tempo seus dados pessoais serão armazenados"),
  /*#__PURE__*/_createElementVNode("p", null, "Os dados pessoais coletados pelo site são armazenados e utilizados por período de tempo que corresponda ao necessário para atingir as finalidades elencadas neste documento e que considere os direitos de seus titulares, os direitos do controlador do site e as disposições legais ou regulatórias aplicáveis."),
  /*#__PURE__*/_createElementVNode("p", null, "Uma vez expirados os períodos de armazenamento dos dados pessoais, eles são removidos de nossas bases de dados ou anonimizados, salvo nos casos em que houver a possibilidade ou a necessidade de armazenamento em virtude de disposição legal ou regulatória."),
  /*#__PURE__*/_createElementVNode("h2", null, "4. Bases legais para o tratamento de dados pessoais"),
  /*#__PURE__*/_createElementVNode("p", null, "Cada operação de tratamento de dados pessoais precisa ter um fundamento jurídico, ou seja, uma base legal, que nada mais é que uma justificativa que a autorize, prevista na Lei Geral de Proteção de Dados Pessoais."),
  /*#__PURE__*/_createElementVNode("p", null, "Todas as Nossas atividades de tratamento de dados pessoais possuem uma base legal que as fundamenta, dentre as permitidas pela legislação. Mais informações sobre as bases legais que utilizamos para operações de tratamento de dados pessoais específicas podem ser obtidas a partir de nossos canais de contato, informados ao final desta Política."),
  /*#__PURE__*/_createElementVNode("h2", null, "5. Direitos do usuário"),
  /*#__PURE__*/_createElementVNode("p", null, "O usuário do site possui os seguintes direitos, conferidos pela Lei de Proteção de Dados Pessoais:"),
  /*#__PURE__*/_createElementVNode("p", null, "– confirmação da existência de tratamento;"),
  /*#__PURE__*/_createElementVNode("p", null, "– acesso aos dados;"),
  /*#__PURE__*/_createElementVNode("p", null, "– correção de dados incompletos, inexatos ou desatualizados;"),
  /*#__PURE__*/_createElementVNode("p", null, "– anonimização, bloqueio ou eliminação de dados desnecessários, excessivos ou tratados em desconformidade com o disposto na lei;"),
  /*#__PURE__*/_createElementVNode("p", null, "– portabilidade dos dados a outro fornecedor de serviço ou produto, mediante requisição expressa, de acordo com a regulamentação da autoridade nacional, observados os segredos comercial e industrial;"),
  /*#__PURE__*/_createElementVNode("p", null, "– eliminação dos dados pessoais tratados com o consentimento do titular, exceto nos casos previstos em lei;"),
  /*#__PURE__*/_createElementVNode("p", null, "– informação das entidades públicas e privadas com as quais o controlador realizou uso compartilhado de dados;"),
  /*#__PURE__*/_createElementVNode("p", null, "– informação sobre a possibilidade de não fornecer consentimento e sobre as consequências da negativa;"),
  /*#__PURE__*/_createElementVNode("p", null, "– revogação do consentimento."),
  /*#__PURE__*/_createElementVNode("p", null, "É importante destacar que, nos termos da LGPD, não existe um direito de eliminação de dados tratados com fundamento em bases legais distintas do consentimento, a menos que os dados seja desnecessários, excessivos ou tratados em desconformidade com o previsto na lei."),
  /*#__PURE__*/_createElementVNode("h3", null, "5.1. Como o titular pode exercer seus direitos"),
  /*#__PURE__*/_createElementVNode("p", null, "Para garantir que o usuário que pretende exercer seus direitos é, de fato, o titular dos dados pessoais objeto da requisição, poderemos solicitar documentos ou outras informações que possam auxiliar em sua correta identificação, a fim de resguardar nossos direitos e os direitos de terceiros. Isto somente será feito, porém, se for absolutamente necessário, e o requerente receberá todas as informações relacionadas."),
  /*#__PURE__*/_createElementVNode("h2", null, "6. Medidas de segurança no tratamento de dados pessoais"),
  /*#__PURE__*/_createElementVNode("p", null, "Empregamos medidas técnicas e organizativas aptas a proteger os dados pessoais de acessos não autorizados e de situações de destruição, perda, extravio ou alteração desses dados."),
  /*#__PURE__*/_createElementVNode("p", null, "As medidas que utilizamos levam em consideração a natureza dos dados, o contexto e a finalidade do tratamento, os riscos que uma eventual violação geraria para os direitos e liberdades do usuário, e os padrões atualmente empregados no mercado por empresas semelhantes à nossa."),
  /*#__PURE__*/_createElementVNode("p", null, "Entre as medidas de segurança adotadas por nós, destacamos as seguintes:"),
  /*#__PURE__*/_createElementVNode("p", null, "– Criptografia por SSL"),
  /*#__PURE__*/_createElementVNode("p", null, "– Acesso ao banco de dados restrito ao proprietário e administrador"),
  /*#__PURE__*/_createElementVNode("p", null, "Ainda que adote tudo o que está ao seu alcance para evitar incidentes de segurança, é possível que ocorra algum problema motivado exclusivamente por um terceiro – como em caso de ataques de hackers ou crackers ou, ainda, em caso de culpa exclusiva do usuário, que ocorre, por exemplo, quando ele mesmo transfere seus dados a terceiro. Assim, embora sejamos, em geral, responsáveis pelos dados pessoais que tratamos, nos eximimos de responsabilidade caso ocorra uma situação excepcional como essas, sobre as quais não temos nenhum tipo de controle."),
  /*#__PURE__*/_createElementVNode("p", null, "De qualquer forma, caso ocorra qualquer tipo de incidente de segurança que possa gerar risco ou dano relevante para qualquer de nossos usuários, comunicaremos os afetados e a Autoridade Nacional de Proteção de Dados acerca do ocorrido, em conformidade com o disposto na Lei Geral de Proteção de Dados."),
  /*#__PURE__*/_createElementVNode("h2", null, "7. Reclamação a uma autoridade de controle"),
  /*#__PURE__*/_createElementVNode("p", null, "Sem prejuízo de qualquer outra via de recurso administrativo ou judicial, os titulares de dados pessoais que se sentirem, de qualquer forma, lesados, podem apresentar reclamação à Autoridade Nacional de Proteção de Dados."),
  /*#__PURE__*/_createElementVNode("h2", null, "8. Alterações nesta política"),
  /*#__PURE__*/_createElementVNode("p", null, "A presente versão desta Política de Privacidade foi atualizada pela última vez em: 17/06/2022."),
  /*#__PURE__*/_createElementVNode("p", null, "Reservamo-nos o direito de modificar, a qualquer momento, as presentes normas, especialmente para adaptá-las às eventuais alterações feitas em nosso site, seja pela disponibilização de novas funcionalidades, seja pela supressão ou modificação daquelas já existentes."),
  /*#__PURE__*/_createElementVNode("p", null, "Sempre que houver uma modificação, nossos usuários serão notificados acerca da mudança."),
  /*#__PURE__*/_createElementVNode("h2", null, "9. Como entrar em contato conosco"),
  /*#__PURE__*/_createElementVNode("p", null, "Para esclarecer quaisquer dúvidas sobre esta Política de Privacidade ou sobre os dados pessoais que tratamos, entre em contato por algum dos canais mencionados abaixo:"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "E-mail:"),
    /*#__PURE__*/_createTextVNode(" hergen@hergen.com.br")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Endereço postal:"),
    /*#__PURE__*/_createTextVNode(" Rua Arnoldo Hoffmann, 35, Rainha, Rio do Sul / SC, Brasil, 89162-028")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    style: {"height":"30px"},
    "aria-hidden": "true",
    class: "wp-block-spacer"
  })
], -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Concluir Cadastro")
], -1)
const _hoisted_86 = [
  _hoisted_85
]
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"50px"} }, null, -1)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("h3", { style: {"font-weight":"900"} }, "Aceite nosso Termo de Consentimento para Tratamento de Dados Pessoais", -1)
const _hoisted_89 = /*#__PURE__*/_createElementVNode("p", null, "Eu, na qualidade de usuário visitante do site www.arg.ind.br, titular dos dados pessoais informados no meu currículo, reconheço e concordo que a ARG Industrial, doravante denominado \"controlador\", poderá coletar, armazenar, utilizar e processar tais informações para os fins específicos de recrutamento e seleção de candidatos.", -1)
const _hoisted_90 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_91 = /*#__PURE__*/_createElementVNode("p", null, "Ao fornecer meus dados pessoais, estou ciente de que estes serão tratados de acordo com as disposições da Lei Geral de Proteção de Dados (LGPD - Lei nº 13.709/2018) e demais normas aplicáveis, respeitando-se os princípios de finalidade, adequação, necessidade, livre acesso, qualidade dos dados, transparência, segurança, prevenção, não discriminação e responsabilização.", -1)
const _hoisted_92 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_93 = /*#__PURE__*/_createElementVNode("p", null, "Autorizo expressamente a ARG Industrial a compartilhar meus dados pessoais com terceiros prestadores de serviços que estejam envolvidos no processo de recrutamento e seleção, sempre observando as garantias de segurança e confidencialidade.", -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_95 = /*#__PURE__*/_createElementVNode("p", null, "Declaro ainda estar ciente de que posso revogar este consentimento a qualquer momento, mediante solicitação ao controlador, o que não afetará a legalidade do tratamento dos dados realizado antes da revogação.", -1)
const _hoisted_96 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_97 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_98 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Concluir Cadastro")
], -1)
const _hoisted_99 = [
  _hoisted_98
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_result = _resolveComponent("a-result")!
  const _component_campo_cpf = _resolveComponent("campo-cpf")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_combo_genero = _resolveComponent("combo-genero")!
  const _component_combo_estado_civil = _resolveComponent("combo-estado-civil")!
  const _component_combo_mao_dominante = _resolveComponent("combo-mao-dominante")!
  const _component_selecionar_sim_nao = _resolveComponent("selecionar-sim-nao")!
  const _component_card = _resolveComponent("card")!
  const _component_campo_email = _resolveComponent("campo-email")!
  const _component_campo_telefone = _resolveComponent("campo-telefone")!
  const _component_campo_cep = _resolveComponent("campo-cep")!
  const _component_combo_cidade = _resolveComponent("combo-cidade")!
  const _component_combo_grau_instrucao = _resolveComponent("combo-grau-instrucao")!
  const _component_combo_setor = _resolveComponent("combo-setor")!
  const _component_combo_tempo = _resolveComponent("combo-tempo")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, {
    id: "uni-candidato",
    ref: "el",
    layout: "vertical",
    style: {"text-align":"left"}
  }, {
    default: _withCtx(() => [
      (_ctx.state.cadastroRelizadoComSucesso)
        ? (_openBlock(), _createBlock(_component_a_result, {
            key: 0,
            status: "success",
            title: "Cadastro realizado com sucesso!",
            "sub-title": "Obrigado por querer fazer parte da nossa empresa. Surgindo alguma vaga e correspondendo com o seu perfil entraremos em contato."
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_card, { titulo: "DADOS PESSOAIS" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_a_form_item, { label: "CPF" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_cpf, {
                          valor: _ctx.state.candidato.cpf,
                          "onUpdate:valor": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.candidato.cpf) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_a_form_item, { label: "RG" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.candidato.rg) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.candidato.rg]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_a_form_item, { label: "PIS/NIT" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.candidato.pisNit) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.candidato.pisNit]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_a_form_item, { label: "Nome" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.candidato.nome) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.candidato.nome]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_a_form_item, { label: "Data Nascimento" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_data, {
                          dataSelecionada: _ctx.state.candidato.dataNascimento,
                          "onUpdate:dataSelecionada": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.candidato.dataNascimento) = $event))
                        }, null, 8, ["dataSelecionada"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_a_form_item, { label: "Local de nascimento" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.candidato.naturalidade) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.candidato.naturalidade]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_a_form_item, { label: "Nacionalidade" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.candidato.nacionalidade) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.candidato.nacionalidade]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                ((_ctx.state.codigoContratante === '2'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_a_form_item, { label: "Nome Pai" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.candidato.nomePai) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.candidato.nomePai]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_a_form_item, { label: "Nome Mãe" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.candidato.nomeMae) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.candidato.nomeMae]
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_a_form_item, { label: "Gênero" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_combo_genero, {
                          valor: _ctx.state.candidato.genero,
                          "onUpdate:valor": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.candidato.genero) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_a_form_item, { label: "Estado Civil" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_combo_estado_civil, {
                          valor: _ctx.state.candidato.estadoCivil,
                          "onUpdate:valor": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.candidato.estadoCivil) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_a_form_item, { label: "Mão Dominante" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_combo_mao_dominante, {
                          valor: _ctx.state.candidato.maoDominante,
                          "onUpdate:valor": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.candidato.maoDominante) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_a_form_item, { label: "PCD - Possui Deficiência?" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_sim_nao, {
                          "radio-button": true,
                          valor: _ctx.state.candidato.possuiDeficiencia,
                          "onUpdate:valor": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.candidato.possuiDeficiencia) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                ((_ctx.state.candidato.estadoCivil === 2 && _ctx.state.codigoContratante === '2'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_a_form_item, { label: "Nome Cônjuge" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.candidato.nomeConjuge) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.candidato.nomeConjuge]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_a_form_item, { label: "Local de Trabalho - Cônjuge" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.candidato.localTrabalhoConjugue) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.candidato.localTrabalhoConjugue]
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                ((_ctx.state.candidato.possuiDeficiencia))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_a_form_item, { label: "Deficiência" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.candidato.deficiencia) = $event)),
                              placeholder: "Especifique sua deficiência"
                            }, null, 512), [
                              [_vModelText, _ctx.state.candidato.deficiencia]
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                ((_ctx.state.codigoContratante === '2'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_a_form_item, { label: "Transporte Utilizado" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.candidato.transporteUtilizado) = $event)),
                              placeholder: "Descreva o transporte que você utiliza para ir trabalhar"
                            }, null, 512), [
                              [_vModelText, _ctx.state.candidato.transporteUtilizado]
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_card, { titulo: "INFORMAÇÕES PARA CONTATO" }, {
              default: _withCtx(() => [
                ((_ctx.state.codigoContratante === '2'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_a_form_item, { label: "E-mail" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_email, {
                              valor: _ctx.state.candidato.email,
                              "onUpdate:valor": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.candidato.email) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_a_form_item, { label: "Telefone" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_telefone, {
                              valor: _ctx.state.candidato.telefone,
                              "onUpdate:valor": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.candidato.telefone) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createVNode(_component_a_form_item, { label: "WhatsApp" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_telefone, {
                              valor: _ctx.state.candidato.whatsapp,
                              "onUpdate:valor": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.candidato.whatsapp) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_a_form_item, { label: "Houve Indicação?" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_sim_nao, {
                              "radio-button": true,
                              valor: _ctx.state.houveIndicacao,
                              "onUpdate:valor": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.houveIndicacao) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ]),
                      (_ctx.state.houveIndicacao)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            _createVNode(_component_a_form_item, { label: "Nome do Colaborador que indicou" }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "ant-input",
                                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.candidato.indicacaoColaborador) = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.state.candidato.indicacaoColaborador]
                                ])
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createVNode(_component_a_form_item, { label: "E-mail" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_email, {
                              valor: _ctx.state.candidato.email,
                              "onUpdate:valor": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.candidato.email) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_component_a_form_item, { label: "Telefone" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_telefone, {
                              valor: _ctx.state.candidato.telefone,
                              "onUpdate:valor": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.state.candidato.telefone) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(_component_a_form_item, { label: "WhatsApp" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_telefone, {
                              valor: _ctx.state.candidato.whatsapp,
                              "onUpdate:valor": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.state.candidato.whatsapp) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ])
                    ])),
                ((_ctx.state.codigoContratante === '2'))
                  ? (_openBlock(), _createBlock(_component_card, {
                      key: 2,
                      titulo: "REFERÊNCIAS PESSOAIS"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          class: "ui-button -primary ui-mh-32 ui-full",
                          onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.adicionarReferenciaPessoal()))
                        }, " Adicionar Referência "),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.candidato.referenciasPessoais, (referencia, index) => {
                          return (_openBlock(), _createBlock(_component_card, {
                            key: index,
                            titulo: (index + 1) + 'ª Referência'
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("div", _hoisted_38, [
                                  _createVNode(_component_a_form_item, { label: "Nome" }, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "ant-input",
                                        "onUpdate:modelValue": ($event: any) => ((referencia.nome) = $event)
                                      }, null, 8, _hoisted_39), [
                                        [_vModelText, referencia.nome]
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ])
                              ]),
                              _createElementVNode("button", {
                                class: "ui-button -second ui-mh-32 ui-full",
                                onClick: ($event: any) => (_ctx.removerReferenciaPessoal(index))
                              }, " Remover Referência ", 8, _hoisted_40)
                            ]),
                            _: 2
                          }, 1032, ["titulo"]))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_card, { titulo: "ENDEREÇO/RESIDÊNCIA" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_41, [
                  ((_ctx.state.codigoContratante === '2'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        _createVNode(_component_a_form_item, { label: "Residência própria?" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_sim_nao, {
                              "radio-button": true,
                              valor: _ctx.state.candidato.residenciaPropria,
                              "onUpdate:valor": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state.candidato.residenciaPropria) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_43, [
                    _createVNode(_component_a_form_item, { label: "CEP" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_cep, {
                          onBlur: _cache[27] || (_cache[27] = ($event: any) => (_ctx.consultaCep())),
                          valor: _ctx.state.candidato.cep,
                          "onUpdate:valor": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.state.candidato.cep) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.state.codigoContratante === '2'?'ant-col ant-col-xs-24 ant-col-lg-16 ant-col-xl-12':'ant-col ant-col-xs-24 ant-col-lg-16 ant-col-xl-16')
                  }, [
                    _createVNode(_component_a_form_item, { label: "Endereço/Logradouro" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.state.candidato.endereco) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.candidato.endereco]
                        ])
                      ]),
                      _: 1
                    })
                  ], 2),
                  _createElementVNode("div", _hoisted_44, [
                    _createVNode(_component_a_form_item, { label: "Número" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.state.candidato.numero) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.candidato.numero]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _createVNode(_component_a_form_item, { label: "Complemento" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.state.candidato.complemento) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.candidato.complemento]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createVNode(_component_a_form_item, { label: "Bairro" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.state.candidato.bairro) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.candidato.bairro]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createVNode(_component_a_form_item, { label: "Cidade/UF" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_combo_cidade, {
                          codigo: _ctx.state.candidato.codigoCidade,
                          "onUpdate:codigo": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.state.candidato.codigoCidade) = $event))
                        }, null, 8, ["codigo"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_card, { titulo: "FORMAÇÕES E QUALIFICAÇÕES" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _createVNode(_component_a_form_item, { label: "Grau de Instrução" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_combo_grau_instrucao, {
                          codigo: _ctx.state.candidato.grauInstrucao,
                          "onUpdate:codigo": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.state.candidato.grauInstrucao) = $event))
                        }, null, 8, ["codigo"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    _createVNode(_component_a_form_item, {
                      label: _ctx.state.codigoContratante === '2'? 'Área Pretendida':'Setor Pretendido'
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_combo_setor, {
                          codigo: _ctx.state.candidato.codigoSetor,
                          "onUpdate:codigo": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.state.candidato.codigoSetor) = $event))
                        }, null, 8, ["codigo"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ])
                ]),
                _createVNode(_component_card, { titulo: "CURSOS" }, {
                  default: _withCtx(() => [
                    (_ctx.state.candidato.cursos.length < 3)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "ui-button -primary ui-mh-32 ui-full",
                          onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.adicionarCurso()))
                        }, " Adicionar Curso "))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.candidato.cursos, (curso, index) => {
                      return (_openBlock(), _createBlock(_component_card, {
                        key: index,
                        titulo: (index + 1) + 'º Curso'
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("div", _hoisted_53, [
                              _createVNode(_component_a_form_item, { label: "Curso" }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "ant-input",
                                    "onUpdate:modelValue": ($event: any) => ((curso.curso) = $event)
                                  }, null, 8, _hoisted_54), [
                                    [_vModelText, curso.curso]
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _createElementVNode("div", _hoisted_55, [
                              _createVNode(_component_a_form_item, { label: "Duração" }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    class: "ant-input",
                                    "onUpdate:modelValue": ($event: any) => ((curso.duracao) = $event)
                                  }, null, 8, _hoisted_56), [
                                    [_vModelText, curso.duracao]
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _createElementVNode("div", _hoisted_57, [
                              _createVNode(_component_a_form_item, { label: "Tempo" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_combo_tempo, {
                                    valor: curso.tempo,
                                    "onUpdate:valor": ($event: any) => ((curso.tempo) = $event)
                                  }, null, 8, ["valor", "onUpdate:valor"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _createElementVNode("div", _hoisted_58, [
                              _createVNode(_component_a_form_item, { label: "Ano de Conclusão" }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    class: "ant-input",
                                    "onUpdate:modelValue": ($event: any) => ((curso.anoConclusao) = $event)
                                  }, null, 8, _hoisted_59), [
                                    [_vModelText, curso.anoConclusao]
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _createElementVNode("button", {
                            class: "ui-button -second ui-mh-32 ui-full",
                            onClick: ($event: any) => (_ctx.removerCurso(index))
                          }, " Remover Curso ", 8, _hoisted_60)
                        ]),
                        _: 2
                      }, 1032, ["titulo"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_card, { titulo: "EXPERIÊNCIAS PROFISSIONAIS" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.candidato.experienciaisProfissionais, (experiencia, index) => {
                  return (_openBlock(), _createBlock(_component_card, {
                    key: index,
                    titulo: _ctx.obtemTituloExperiencia(index)
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("div", _hoisted_62, [
                          _createVNode(_component_a_form_item, { label: "Empresa" }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "ant-input",
                                "onUpdate:modelValue": ($event: any) => ((experiencia.empresa) = $event)
                              }, null, 8, _hoisted_63), [
                                [_vModelText, experiencia.empresa]
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createElementVNode("div", _hoisted_64, [
                          _createVNode(_component_a_form_item, { label: "Cargo" }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "ant-input",
                                "onUpdate:modelValue": ($event: any) => ((experiencia.cargo) = $event)
                              }, null, 8, _hoisted_65), [
                                [_vModelText, experiencia.cargo]
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_66, [
                        _createElementVNode("div", _hoisted_67, [
                          _createVNode(_component_a_form_item, { label: "Data Admissão" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_data, {
                                dataSelecionada: experiencia.dataAdmissao,
                                "onUpdate:dataSelecionada": ($event: any) => ((experiencia.dataAdmissao) = $event)
                              }, null, 8, ["dataSelecionada", "onUpdate:dataSelecionada"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createElementVNode("div", _hoisted_68, [
                          _createVNode(_component_a_form_item, { label: "Data Saída" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_data, {
                                dataSelecionada: experiencia.dataSaida,
                                "onUpdate:dataSelecionada": ($event: any) => ((experiencia.dataSaida) = $event)
                              }, null, 8, ["dataSelecionada", "onUpdate:dataSelecionada"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createElementVNode("div", _hoisted_69, [
                          _createVNode(_component_a_form_item, { label: "Motivo Saída" }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "ant-input",
                                "onUpdate:modelValue": ($event: any) => ((experiencia.motivoSaida) = $event)
                              }, null, 8, _hoisted_70), [
                                [_vModelText, experiencia.motivoSaida]
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["titulo"]))
                }), 128))
              ]),
              _: 1
            }),
            ((_ctx.state.codigoContratante === '1'))
              ? (_openBlock(), _createBlock(_component_a_collapse, {
                  key: 0,
                  activeKey: 1,
                  accordion: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_collapse_panel, { key: "1" }, {
                      header: _withCtx(() => [
                        _hoisted_71
                      ]),
                      default: _withCtx(() => [
                        _hoisted_72,
                        _hoisted_73,
                        _hoisted_74,
                        _hoisted_75,
                        _hoisted_76,
                        _hoisted_77,
                        _hoisted_78,
                        _hoisted_79,
                        _hoisted_80,
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.state.aceiteTermo,
                          "onUpdate:checked": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.state.aceiteTermo) = $event)),
                          class: "ui-check-card"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Por meio desta, manifesto meu consentimento livre, informado e inequívoco para o tratamento dos meus dados pessoais conforme descrito acima.")
                          ]),
                          _: 1
                        }, 8, ["checked"]),
                        (_ctx.state.apresentarMensagemAlerta)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.appBase.resposta.mensagens, (mensagem, index) => {
                              return (_openBlock(), _createBlock(_component_a_alert, {
                                key: index,
                                message: mensagem.titulo,
                                description: mensagem.subMensagens[0],
                                type: "warning",
                                "show-icon": ""
                              }, null, 8, ["message", "description"]))
                            }), 128))
                          : _createCommentVNode("", true),
                        (_ctx.state.aceiteTermo)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "ui-button -primary ui-full",
                              type: "button",
                              onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.salvar()))
                            }, _hoisted_82))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            ((_ctx.state.codigoContratante === '2'))
              ? (_openBlock(), _createBlock(_component_a_collapse, {
                  key: 1,
                  activeKey: 1,
                  accordion: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_collapse_panel, { key: "1" }, {
                      header: _withCtx(() => [
                        _hoisted_83
                      ]),
                      default: _withCtx(() => [
                        _hoisted_84,
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.state.aceiteTermo,
                          "onUpdate:checked": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.state.aceiteTermo) = $event)),
                          class: "ui-check-card"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Eu aceito e estou ciente da política descrita acima.")
                          ]),
                          _: 1
                        }, 8, ["checked"]),
                        (_ctx.state.apresentarMensagemAlerta)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.appBase.resposta.mensagens, (mensagem, index) => {
                              return (_openBlock(), _createBlock(_component_a_alert, {
                                key: index,
                                message: mensagem.titulo,
                                description: mensagem.subMensagens[0],
                                type: "warning",
                                "show-icon": ""
                              }, null, 8, ["message", "description"]))
                            }), 128))
                          : _createCommentVNode("", true),
                        (_ctx.state.aceiteTermo)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "ui-button -primary ui-full",
                              type: "button",
                              onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.salvar()))
                            }, _hoisted_86))
                          : _createCommentVNode("", true),
                        _hoisted_87
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            ((_ctx.state.codigoContratante === '3'))
              ? (_openBlock(), _createBlock(_component_a_collapse, {
                  key: 2,
                  activeKey: 1,
                  accordion: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_collapse_panel, { key: "1" }, {
                      header: _withCtx(() => [
                        _hoisted_88
                      ]),
                      default: _withCtx(() => [
                        _hoisted_89,
                        _hoisted_90,
                        _hoisted_91,
                        _hoisted_92,
                        _hoisted_93,
                        _hoisted_94,
                        _hoisted_95,
                        _hoisted_96,
                        _hoisted_97,
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.state.aceiteTermo,
                          "onUpdate:checked": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.state.aceiteTermo) = $event)),
                          class: "ui-check-card"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Por meio desta, manifesto meu consentimento livre, informado e inequívoco para o tratamento dos meus dados pessoais conforme descrito acima.")
                          ]),
                          _: 1
                        }, 8, ["checked"]),
                        (_ctx.state.apresentarMensagemAlerta)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.appBase.resposta.mensagens, (mensagem, index) => {
                              return (_openBlock(), _createBlock(_component_a_alert, {
                                key: index,
                                message: mensagem.titulo,
                                description: mensagem.subMensagens[0],
                                type: "warning",
                                "show-icon": ""
                              }, null, 8, ["message", "description"]))
                            }), 128))
                          : _createCommentVNode("", true),
                        (_ctx.state.aceiteTermo)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "ui-button -primary ui-full",
                              type: "button",
                              onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.salvar()))
                            }, _hoisted_99))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
    ]),
    _: 1
  }, 512))
}